export enum ShortShipConfirmationOption {
  CONFIRM = "CONFIRM",
  INVESTIGATE = "INVESTIGATE",
}
